module.exports = __webpack_public_path__ + "img/progress.2d32f6f3.png";